import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from 'footer';
import { NavigationComponent } from 'navigation';

@Component({
  selector: 'app-landing-page-container',
  templateUrl: './landing-page-container.component.html',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, NavigationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingPageContainerComponent {}
